import { Route, Switch, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { PricesView } from './prices.view';

export const PricesRouter = () => {
  let { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <PricesView />
        </Route>
      </Switch>
    </div>
  );
};
